<div>
    <h1>Not found</h1>
    <button mat-raised-button routerLink='/'>Return to home</button>
</div> 